export default __webpack_public_path__ + "static/media/128x128.55580548.jpg";